import Modal from 'components/Modal/Modal'
import { ReactComponent as PictoCheck } from 'assets/default/svg/calculator/pictocheck.svg'
import { ReactComponent as PictoCroix } from 'assets/default/svg/calculator/pictocroix.svg'
import IconSelector from 'components/Form/Helpers/IconSelector/IconSelector'
import { initGarage, showCalculator } from 'redux/features/bienAVendre/slice'
import { useAppSelector, useAppDispatch } from 'redux/hooks'
import { Button } from 'react-bootstrap'
import {
  makeSelectShowedCalculator,
  makeSelectGarage,
} from 'redux/features/bienAVendre/selectors'
import styles from './PresenceGarage.module.scss'

interface Props {
  onContinueButtonClick: () => void
}

const PresenceGarage = ({ onContinueButtonClick }: Props): JSX.Element => {
  const showedCalculator = useAppSelector(makeSelectShowedCalculator)
  const garage = useAppSelector(makeSelectGarage)
  const dispatch = useAppDispatch()

  return (
    <Modal
      show={showedCalculator}
      title="Calculateur avancé de l'emprise au sol estimée"
      body={
        <>
          <h1 className={styles.title}>
            La maison est-elle équipée d&apos;un garage attenant?
          </h1>
          <p className={styles.text}>
            Le garage attenant est un garage de stationnement incorporé ou
            contigu au bâtiment d&apos;habitation.
          </p>
          <IconSelector
            onChange={(value) => dispatch(initGarage(value as number))}
            value={garage}
            options={[
              {
                icon: <PictoCheck className={styles.pictocheck} />,
                label: 'Oui',
                value: 1,
              },
              {
                icon: <PictoCroix className={styles.pictocroix} />,
                label: 'Non',
                value: 2,
              },
            ]}
          />
        </>
      }
      footer={
        <Button
          variant="primary"
          onClick={onContinueButtonClick}
          disabled={!garage}
        >
          Continuer
        </Button>
      }
      onCloseButtonClick={() => dispatch(showCalculator(false))}
    />
  )
}

export default PresenceGarage
